 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML01_TITLE_PA from '@/components/html/01_Title_pa'
 import HTML03_DEDICATI from '@/components/html/03_Dedicati'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_INTRODUC from '@/components/html/05_Introduc'
 import HTML06_PART_1_N from '@/components/html/06_PART_1_N'
 import HTML07_PART_2_O from '@/components/html/07_PART_2_O'
 import HTML08_I__POPUL from '@/components/html/08_I__POPUL'
 import HTML09_A__THE_G from '@/components/html/09_A__The_G'
 import HTML10_B__EXHAU from '@/components/html/10_B__Exhau'
 import HTML11_C__EXHAU from '@/components/html/11_C__Exhau'
 import HTML12_II__TOWA from '@/components/html/12_II__TOWA'
 import HTML13_D__PROCE from '@/components/html/13_D__Proce'
 import HTML14_E__PROCE from '@/components/html/14_E__Proce'
 import HTML15_III__THE from '@/components/html/15_III__THE'
 import HTML16_F__ANOTH from '@/components/html/16_F__Anoth'
 import HTML17_EPILOGUE from '@/components/html/17_Epilogue'
 import HTML18_ABOUT_TH from '@/components/html/18_About_th'
 import HTML19_ACKNOWLE from '@/components/html/19_Acknowle'
 import HTML20_SELECTED from '@/components/html/20_Selected'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Introduc",
 			"name" : "html/05_Introduc",
 			"component" : HTML05_INTRODUC
 		},
 		{
 			"path" : "/html/06_PART_1_N",
 			"name" : "html/06_PART_1_N",
 			"component" : HTML06_PART_1_N
 		},
 		{
 			"path" : "/html/07_PART_2_O",
 			"name" : "html/07_PART_2_O",
 			"component" : HTML07_PART_2_O
 		},
 		{
 			"path" : "/html/08_I__POPUL",
 			"name" : "html/08_I__POPUL",
 			"component" : HTML08_I__POPUL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js